import { render, staticRenderFns } from "./editDefaultTemplate.vue?vue&type=template&id=0a1232b0&lang=pug"
import script from "./editDefaultTemplate.vue?vue&type=script&lang=js"
export * from "./editDefaultTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports